import React from "react";

interface ErrorToastProps {
  message: string;
  isVisible: boolean;
}

export default function ErrorToast({ message, isVisible }: ErrorToastProps) {
  if (!isVisible) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: "20px",
        left: "50%",
        transform: "translateX(-50%)",
        backgroundColor: "#dc3545",
        color: "white",
        padding: "1rem 1.5rem",
        borderRadius: "4px",
        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1), 0 2px 4px rgba(0, 0, 0, 0.06)",
        zIndex: 10000,
        maxWidth: "90%",
        textAlign: "center",
        fontSize: "1rem",
        fontWeight: "500"
      }}
    >
      {message}
    </div>
  );
}

